import "./GoToAdvAnalytics.scss";
import images from "../../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const GoToAdvAnalytics = () => {
  const history = useHistory();

  const goToAnalytics = () => {
    history.push("/adv-analytics");
  };

  return (
    <div
      className="goToAdvAnalytics"
      onClick={goToAnalytics}
      style={{ cursor: "pointer" }}
    >
      <div className="goToAdvAnalytics__left">
        <img src={images.analytics} alt="analytics" />
        <div>See Your Advanced Analytics</div>
      </div>

      <div className="goToAdvAnalytics__rightbtn">
        <img src={images.backBtn} alt="right" />
      </div>
    </div>
  );
};

export default GoToAdvAnalytics;
